import React, {useEffect, useRef} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";

import {setLookCompatabilityAlert} from "../../../../../actions/lookFunctions";
import LookCompatabilitySectionButtons from "./lookCompatabilitySectionButtons";
import LookCompatabilitySectionContent from "./lookCompatabilitySectionContent";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import $ from "jquery";

const LookCompatabilitySection = (props) => {
  const {lookCompatabilityAlert, wrapperStyles, intl, isMobile} = props;

  const compatabilityContentElem = useRef();

  //console.log("availableFilters", availableFilters);

  useEffect(() => {
    if (lookCompatabilityAlert.visible) {
      setTimeout(() => {
        if (compatabilityContentElem && compatabilityContentElem.current) {
          const buttons = $(compatabilityContentElem.current).find(".look-popup__buttons");
          if (buttons && buttons[0] && buttons[0].offsetTop) {
            $(compatabilityContentElem.current).animate({scrollTop: buttons[0].offsetTop}, 1300);
          }
        }
      }, 700);
    }
  }, [lookCompatabilityAlert])

  return (
    <div className={IS_PRODUCT_JOURNEY
      ? "lm-content"
      : "lm-content lm-content--filters" + (!lookCompatabilityAlert.visible ? " lm-content--slide-up" : "")}
         ref={compatabilityContentElem}
         style={wrapperStyles || {}}>
      <div className={"grohe-container grohe-filters"
        + (IS_PRODUCT_JOURNEY && !isMobile ? " grohe-container--no-top-padding" : "")}>
        <div className="lk-title lk-title--start">
          <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                      className="look-icon look-icon--small look-icon--yellow">
            <ErrorIcon/>
          </IconButton>
          <h2 className="h3 h3--no-margin lk-title__text2">
            <FormattedMessage id="look.feature.compatability.title"/>
          </h2>
        </div>
        <p className={"lk-description" + (IS_PRODUCT_JOURNEY && isMobile ? " lk-description--no-margin" : "")}>
          <FormattedMessage id="look.feature.compatability.subTitle"/>
        </p>
        <LookCompatabilitySectionContent/>
        <LookCompatabilitySectionButtons/>
      </div>
    </div>
  )
};

LookCompatabilitySection.propTypes = {
  wrapperStyles: PropTypes.object
}

const mapStateToProps = (store) => {
  const {lookCompatabilityAlert, lookActiveFeature} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveFeature,
    lookCompatabilityAlert,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookCompatabilityAlert
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookCompatabilitySection)
);
